import React from 'react';
import { useContext } from 'react';
import { StateContext } from '../../StateContainer';

const IntentModal = () => {
  const {
    // Nodes
    nodes,

    // Dettagli nodi
    setDettagliNodi,

    // Selected Node
    setSelectedNode,

    // Selected Edge
    selectedEdge,
    setSelectedEdge,

    // Show modal variables
    setShowModalVariables,
  } = useContext(StateContext);

  const closeModal = () => {
    setSelectedNode(null);
    setShowModalVariables(false);
    setSelectedEdge(null);
  };

  const handleSaveIntent = (trigger, target, output_intent, forceIntent) => {
    setDettagliNodi((prev) => {
      const updatedDetails = { ...prev };
      const sourceNodeId = selectedEdge.source;

      if (!updatedDetails[`nodo-${sourceNodeId}`]?.intents) return prev;

      const intentIndex = updatedDetails[
        `nodo-${sourceNodeId}`
      ].intents.findIndex((intent) => intent.target === selectedEdge.target);

      if (intentIndex !== -1) {
        if (!updatedDetails[`nodo-${sourceNodeId}`]) {
          updatedDetails[`nodo-${sourceNodeId}`] = { intents: [] };
        }

        updatedDetails[`nodo-${sourceNodeId}`].intents[intentIndex] = {
          trigger,
          output_intent,
          forceIntent,
          target,
          id: `${sourceNodeId}-${selectedEdge.target}`,
          source: sourceNodeId,
          target: selectedEdge.target,
          type:
            sourceNodeId === selectedEdge.target
              ? 'selfconnecting'
              : 'custom_edge',
          animated: true,
        };
      }

      return updatedDetails;
    });

    closeModal();
  };

  console.log('selectedEdge', selectedEdge);
  return (
    <div
      className="d-block"
      tabIndex="-1"
      role="dialog"
      style={{ backgroundColor: '#F0F0F0' }}
    >
      <div className="modal-lg d-flex w-100" role="document">
        <div
          className="content-popup d-flex flex-column"
          style={{
            borderRadius: '10px',
            overflow: 'hidden',
            border: '1px solid #888888',
            width: '50%',
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)',
            position: 'absolute',
            minHeight: '680px',
            backgroundColor: '#F0F0F0',
            maxHeight: '680px',
          }}
        >
          <div className="d-flex justify-content-between mb-4 bg-orange py-3 px-3">
            <div></div>
            <p className="fs-5 text-white">{`Intento #${selectedEdge.id}`}</p>
            <button
              type="button"
              className="btn-close"
              onClick={closeModal}
              aria-label="Close"
            ></button>
          </div>
          <div className="px-4 flex-grow-1">
            <label htmlFor="obiettivo-nodo" className="form-label mt-2">
              Trigger
            </label>
            <p className="text-secondary mb-3">
              Indica l'azione che l'utente deve compiere per passare al nodo
              successivo
            </p>
            <div className="input-group mb-3">
              <textarea
                className="form-control"
                placeholder="Trigger"
                id="trigger-intent"
                value={selectedEdge?.trigger || ''}
                onChange={(e) => {
                  const newTrigger = e.target.value;

                  setSelectedEdge((prev) => ({
                    ...prev,
                    trigger: newTrigger, // Update selectedEdge
                  }));

                  setDettagliNodi((prev) => {
                    const updatedDetails = { ...prev };
                    const sourceNodeId = selectedEdge?.source;

                    if (!sourceNodeId) return prev; // Ensure sourceNodeId is defined

                    // Ensure nodo-{sourceNodeId} exists
                    if (!updatedDetails[`nodo-${sourceNodeId}`]) {
                      updatedDetails[`nodo-${sourceNodeId}`] = {
                        intents: [],
                      };
                    }

                    // Ensure intents array exists
                    if (!updatedDetails[`nodo-${sourceNodeId}`].intents) {
                      updatedDetails[`nodo-${sourceNodeId}`].intents = [];
                    }

                    // Fixing possible typo in key (` nodo-${sourceNodeId}` -> `nodo-${sourceNodeId}`)
                    const intentIndex = updatedDetails[
                      `nodo-${sourceNodeId}`
                    ].intents.findIndex(
                      (intent) => intent.target === selectedEdge?.target
                    );

                    if (intentIndex !== -1) {
                      updatedDetails[`nodo-${sourceNodeId}`].intents[
                        intentIndex
                      ].trigger = newTrigger;
                    }

                    return updatedDetails;
                  });
                }}
              />
            </div>

            <label htmlFor="obiettivo-nodo" className="form-label mt-2">
              Output dell'intent
            </label>
            <p className="text-secondary mb-3">
              Il messaggio che verrà visualizzato dall'utente alla scelta
              dell'intent
            </p>

            <div className="input-group mb-3">
              <textarea
                className="form-control"
                placeholder="Output dell'intent"
                id="output_intent"
                value={selectedEdge?.output_intent || ''}
                onChange={(e) => {
                  const newOutputIntent = e.target.value;

                  setSelectedEdge((prev) => ({
                    ...prev,
                    output_intent: newOutputIntent, // Update selectedEdge
                  }));

                  setDettagliNodi((prev) => {
                    const updatedDetails = { ...prev };
                    const sourceNodeId = selectedEdge?.source;

                    if (!sourceNodeId) return prev; // Ensure sourceNodeId is defined

                    // Ensure nodo-{sourceNodeId} exists
                    if (!updatedDetails[`nodo-${sourceNodeId}`]) {
                      updatedDetails[`nodo-${sourceNodeId}`] = {
                        intents: [],
                      };
                    }

                    // Ensure intents array exists
                    if (!updatedDetails[`nodo-${sourceNodeId}`].intents) {
                      updatedDetails[`nodo-${sourceNodeId}`].intents = [];
                    }

                    // Fixing possible typo in key (` nodo-${sourceNodeId}` -> `nodo-${sourceNodeId}`)
                    const intentIndex = updatedDetails[
                      `nodo-${sourceNodeId}`
                    ].intents.findIndex(
                      (intent) => intent.target === selectedEdge?.target
                    );

                    if (intentIndex !== -1) {
                      updatedDetails[`nodo-${sourceNodeId}`].intents[
                        intentIndex
                      ].output_intent = newOutputIntent;
                    }

                    return updatedDetails;
                  });
                }}
              />
            </div>

            <label htmlFor="obiettivo-nodo" className="form-label mt-2">
              Forza intent
            </label>
            <p className="text-secondary mb-3">
              Se valorizzato, obbligherà l'assistente a scegliere questo intento
              senza fare alcuna verifica
            </p>
            <div className="form-check form-switch mb-3">
              <input
                className="form-check-input"
                type="checkbox"
                id="flexSwitchCheckChecked"
                checked={selectedEdge?.forceIntent}
                onChange={(e) => {
                  const newForceIntent = e.target.checked;

                  setSelectedEdge((prev) => ({
                    ...prev,
                    forceIntent: newForceIntent, // Update selectedEdge
                  }));

                  setDettagliNodi((prev) => {
                    const updatedDetails = { ...prev };
                    const sourceNodeId = selectedEdge?.source;

                    if (!sourceNodeId) return prev; // Ensure sourceNodeId is defined

                    // Ensure nodo-{sourceNodeId} exists
                    if (!updatedDetails[`nodo-${sourceNodeId}`]) {
                      updatedDetails[`nodo-${sourceNodeId}`] = {
                        intents: [],
                      };
                    }

                    // Ensure intents array exists
                    if (!updatedDetails[`nodo-${sourceNodeId}`].intents) {
                      updatedDetails[`nodo-${sourceNodeId}`].intents = [];
                    }

                    // Fixing possible typo in key (` nodo-${sourceNodeId}` -> `nodo-${sourceNodeId}`)
                    const intentIndex = updatedDetails[
                      `nodo-${sourceNodeId}`
                    ].intents.findIndex(
                      (intent) => intent.target === selectedEdge?.target
                    );

                    if (intentIndex !== -1) {
                      updatedDetails[`nodo-${sourceNodeId}`].intents[
                        intentIndex
                      ].forceIntent = newForceIntent;
                    }

                    return updatedDetails;
                  });
                }}
              />
            </div>
            <label htmlFor="info-nodo-collegato" className="form-label mt-2">
              Nodo collegato
            </label>
            <p id="info-nodo-collegato">
              {nodes.find((node) => node.id === selectedEdge.target)
                ? `Nodo ${
                    nodes.find((node) => node.id === selectedEdge.target).id
                  } - ${
                    nodes.find((node) => node.id === selectedEdge.target).data
                      .label
                  }`
                : 'Nessun nodo selezionato'}
            </p>
          </div>
          {/* Add the button here, make sure it's aligned at the bottom */}
          <div className="d-flex justify-content-end mt-auto p-4 gap-2">
            <button className="btn btn-secondary" onClick={closeModal}>
              Annulla
            </button>
            <button
              onClick={() =>
                handleSaveIntent(
                  selectedEdge.trigger,
                  selectedEdge.target,
                  selectedEdge.output_intent,
                  selectedEdge.forceIntent
                )
              }
              className="btn btn-primary"
            >
              Salva
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IntentModal;
